import { render, staticRenderFns } from "./accountPlan.vue?vue&type=template&id=4b9603cc&scoped=true&"
import script from "./accountPlan.vue?vue&type=script&lang=js&"
export * from "./accountPlan.vue?vue&type=script&lang=js&"
import style0 from "./accountPlan.vue?vue&type=style&index=0&id=4b9603cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9603cc",
  null
  
)

export default component.exports